import * as dom from './dom-utils';
import * as sc from './sc-utils';
import * as gs from './gs-utils';
import * as math from './math-utils';
import * as string from './string-utils';
import * as obj from './obj-utils';
import * as sp from './sp-utils';
import * as overall from './overall-utils';
import * as device from './device-utils';
import * as form from './form-utils';
import * as date from './date-utils';
const utils = {
  obj,
  dom,
  sc,
  gs,
  math,
  string,
  sp,
  overall,
  device,
  form,
  date,
};
export default utils;
